import React, { createRef, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { createMuiTheme, Fab, makeStyles, MuiThemeProvider, Paper, Radio, Tab, TableCell, Tabs, TextField, Typography } from "@material-ui/core";
import MUIDataTable from 'mui-datatables';
import { withStyles } from '@material-ui/styles';
import { green } from '@material-ui/core/colors';
import { useLocation } from 'react-router';
import { usePrevious } from '../../library/Util';
import api from '../api';
import editIcon from '../../assets/ic_detail.png';
import CloseImage from '../../assets/ic_close.png';
// import CloseImage from '../../assets/ic_close.png';

const pageStyle = `{size: 3.075in 10.25in}`;
const pageStyleTiket = `{size: 5cm 7.3cm}`;

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());

const options = ct.customOptions()

const GreenRadio = withStyles({
    root: {
        color: green[400],
        '&$checked': {
            color: green[600],
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper
    },
    tabsIndicator: {
        backgroundColor: "#2a9c6c"
    },
    tabRoot: {
        "&:hover": {
            color: "red",
            opacity: 1
        },
        "&$tabSelected": {
            color: "red",
            fontWeight: theme.typography.fontWeightMedium
        },
        "&:focus": {
            color: "red"
        }
    },
    tabSelected: {},
    fab: {
        '& > *': {
            margin: theme.spacing(1),
        },
        position: 'fixed',
        right: 25,
        top: 65
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
}))

const style = {
    position: "sticky",
    zIndex: 110
};

export default function HasilLab(props) {
    const [list, setList] = React.useState([])
    const prevCount = usePrevious(list);
    const [dataBaru, setDataBaru] = useState([])
    const [detail, setDetail] = React.useState([])
    const [loading, setLoading] = React.useState(false)
    const [visibleEdit, setVisibleEdit] = React.useState(false)
    const [namaPasien, setNamaPasien] = React.useState("")
    const [addCatatan, setAddCatatan] = React.useState(false)
    const [newNotes, setNewNotes] = React.useState("")
    const [noAntri, setNoAntri] = React.useState("");
    const [noBilling, setNoBilling] = React.useState("");
    const [kodePesanan, setKodePesanan] = React.useState("")
    const [noReferensi, setNoReferensi] = React.useState("")
    const [lokasi, setLokasi] = React.useState(null);
    const [noRM, setNoRM] = React.useState("")
    const [visibleStatus, setVisibleStatus] = React.useState(false)
    const [visibleSelesai, setVisibleSelesai] = React.useState(false)
    const [rowData, setRowData] = React.useState(new Date())
    const [visibleError, setVisibleError] = React.useState(false)
    const [errorMessage, setErrorMessage] = React.useState("")
    const [notes, setNotes] = React.useState("")

    useEffect(() => {
        // console.log('tes');
        if (list.length != (prevCount !== undefined ? prevCount.length : -1)) {
            // getListCounter()
            getDataTable()
        }
        const interval = setInterval(() => {
            getDataTable()
        }, 3000);
        return () => clearInterval(interval);
    }, [dataBaru])

    const getDataTable = () => {
        api.create().getListLaboratorium().then(response => {
            // console.log(response);
            if (response.data) {
                if (response.data) {
                    if (response.data.data.length > 0) {
                        let data = response.data.data.map((item, index) => {
                            // console.log(item);
                            return [
                                index + 1,
                                item.queue_number,
                                item.production_date,
                                item.reference_no,
                                item.patient_name === null ? item.patient_name_2 : item.patient_name ,
                                item.patient_date_of_birth,
                                item.patient_medical_record_no === null ? item.patient_medical_record_no_2 : item.patient_medical_record_no ,
                                item.polyclinic_name === null ? item.polyclinic_name_2 : item.polyclinic_name,
                                item.doctor_name === null ? item.doctor_name_2 : item.doctor_name,
                                item.payment_option_name,
                                item.status_name,
                                item.id,
                            ]
                        })
                        setList(data)
                    } else {
                        setDataBaru([])
                        // setDataLama([])
                    }
                    setDataBaru(response.data.data)
                }
            }
        })
    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const onClose = () => {
        setVisibleEdit(false)
        setVisibleStatus(false)
        setVisibleSelesai(false)
    };

    const handleSelesai = ({ rowData }) => {
        console.log(detail);
        console.log(rowData);
        console.log(notes);
        if (rowData[10] === "Menunggu Hasil") {
            let payload = {
                "id": rowData[11],
                "status": 3
                
            }
            setVisibleSelesai(true)
            setDetail(rowData)
            setRowData(payload)
        } else {
            let payload = {
                "id": rowData[11],
                "status": 4,
                // "notes": notes
            }
            setVisibleStatus(true)
            setDetail(rowData)
            setRowData(payload)
        }

    }

    const changeStatus = () => {
        setLoading(false)
        let payload = rowData
        payload = {
            ...payload,
            "notes": notes,
        }
        console.log(payload);
        api.create().changeStatusLab(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    // getListCounter()
                    setVisibleSelesai(false)
                    setVisibleStatus(false)
                } else {
                    setVisibleError(true)
                    setErrorMessage(response.data.data)
                }
                setLoading(false)
            }
        })
    }

    const handleEdit = ({ rowData }) => {
        console.log(rowData);
        api.create().getDetailMonitoringLab(rowData[11]).then(response => {
            console.log(response);
            if (response.data) {
                let data = response.data.data
                if (response.data.status === true) {
                    setLokasi(data.facility.name)
                    setNamaPasien(data.patient_name === null ? data.patient_name_2 : data.patient_name )
                    setNoReferensi(data.reference_no)
                    setKodePesanan(data.booking_id)
                    setNoAntri(data.queue_number)
                    setNoBilling(data.bill_number)
                    setNoRM(data.patient_medical_record_no === null ? data.patient_medical_record_no_2 : data.patient_medical_record_no )
                    setVisibleEdit(true)
                }
            }
        })
        // getDetailResep(rowData)
    }

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 1000, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    const columns = ["No", "No. Antrian", "Tanggal", "No. Referensi", "Nama Pasien", "Tanggal Lahir", "No RM", "Klinik", "Dokter", "Opsi Pembayaran", "Status",
        {
            name: "Aksi",
            options: {
                filter: false,
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 110, backgroundColor: 'white', }}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    // console.log(tableMeta);
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            {
                                tableMeta.rowData[10] === "Menunggu Hasil" ?
                                    <div>
                                        <button
                                            id='btn'
                                            style={{ borderColor: 'transparent', backgroundColor: '#4cdc63', borderRadius: 20, width: 100, marginLeft: 10 }}
                                            onClick={() => handleSelesai(tableMeta)}
                                        >
                                            <Typography style={{ color: 'white' }}>Selesai</Typography>
                                        </button>
                                        <button
                                            onClick={() => handleEdit(tableMeta)}
                                            style={{
                                                backgroundColor: "transparent",
                                                fontSize: 20,
                                                outline: 'none',
                                                borderColor: 'transparent',
                                                marginRight: 20
                                            }}>
                                            <img src={editIcon} style={{ width: 30, height: 30 }} />
                                        </button>
                                    </div>
                                    :
                                    tableMeta.rowData[10] === "Hasil Selesai" ?
                                        <div>
                                            <button
                                                id='btn'
                                                style={{ borderColor: 'transparent', backgroundColor: '#4cdc63', borderRadius: 20, width: 100, marginLeft: 10 }}
                                                onClick={() => handleSelesai(tableMeta)}
                                            >
                                                <Typography style={{ color: 'white' }}>Diserahkan</Typography>
                                            </button>
                                            <button
                                                onClick={() => handleEdit(tableMeta)}
                                                style={{
                                                    backgroundColor: "transparent",
                                                    fontSize: 20,
                                                    outline: 'none',
                                                    borderColor: 'transparent',
                                                    marginRight: 20
                                                }}>
                                                <img src={editIcon} style={{ width: 30, height: 30 }} />
                                            </button>
                                        </div>
                                        :
                                        null
                            }


                        </div>
                    )
                }
            }
        },
        {
            name: "id",
            options: {
                display: false,
                filter: false
            }
        },
    ]

    return (
        <div>
            <Paper style={{ boxShadow: 'none' }} >
                <div style={{ width: '100%', display: 'grid' }}>
                    {loading && (loadingComponent)}
                </div>
            </Paper>
            <div style={{}}>
                <Paper style={{ width: '100%', borderRadius: 20, boxShadow: '5px 5px 10px 0 #999999', marginTop: 20, padding: 10, zIndex: 2 }} >
                    <MuiThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                            data={list}
                            columns={columns}
                            options={options}
                        />
                    </MuiThemeProvider>
                </Paper>
            </div>

            {visibleStatus && (
                <div className="App app-popup-show" style={{ zIndex: 5000 }}>
                    <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
                        <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'black', fontSize: 18 }}>Tambah Catatan</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => {
                                        setVisibleStatus(false)
                                    }}
                                >
                                    <img src={CloseImage} />
                                </button>
                            </div>
                        </div>
                        <div style={{ height: '32vh', marginLeft: 30, textAlign: 'left' }}>
                            <Typography style={{ marginTop: 15, textAlign: 'left', fontSize: 16 }}>Apakah anda yakin hasil Laboratorium telah diserahkan kepada pasien <span><b>{detail[4]}</b></span> ? </Typography>
                            <Typography style={{ textAlign: 'left', width: '70%', paddingTop: 35 }}>Catatan Baru</Typography>
                            <textarea
                                label="Catatan Petugas"
                                value={notes}
                                onChange={(e) => {
                                    setNotes(e.target.value)
                                }}
                                style={{ width: '96%', marginTop: 10, height: '15vh', textAlign: 'left' }}
                                placeholder={"input catatan baru"}
                            />
                            <Typography style={{ textAlign: 'left', fontSize: 12, color: 'rgb(255, 91, 91)' }}>Note: catatan yang sudah ditambahkan tidak bisa diubah</Typography>
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div
                                    onClick={() => onClose()}
                                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                </div>
                                <div
                                    onClick={() => changeStatus()}
                                    style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {visibleSelesai && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" />
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => onClose()}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div style={{ padding: 20 }}>
                            <Typography style={{ marginTop: 15, textAlign: 'left', fontSize: 16 }}>Apakah anda yakin akan merubah status hasil lab untuk pasien atas nama <span><b>{detail[4]}</b></span> ? </Typography>
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div
                                    onClick={() => onClose()}
                                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                </div>
                                <div
                                    onClick={() => changeStatus()}
                                    style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {visibleEdit && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8 }}>
                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8, backgroundColor: '#278863' }}>
                            <div style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'white', fontSize: 18, marginLeft: 20 }}>Detail Hasil Laboratorium</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => onClose()}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div className={"nav__body"} style={{ backgroundColor: 'white', height: '100%', width: '100%', borderBottomRightRadius: 8, borderBottomLeftRadius: 8 }}>
                            {/* <div style={{ padding: 20, display: 'flex', justifyContent: 'flex-end' }}>
                                <button style={{ outline: 'none', backgroundColor: 'transparent', borderColor: 'transparent' }} onClick={() => setAddCatatan(true)}>
                                    <Typography style={{ marginBottom: 10, fontWeight: 'bold', color: '#0066ff', textAlign: 'right', fontSize: 16 }}>+ Tambah Catatan</Typography>
                                </button>
                            </div> */}
                            <div style={{ paddingLeft: 30, paddingRight: 30 }}>
                                <TextField
                                    style={{ width: '100%', marginTop: 30 }}
                                    id="noBill"
                                    disabled={true}
                                    name="noBill"
                                    label="No. Billing"
                                    placeholder={"input No. Billing"}
                                    value={noBilling}
                                    onChange={(e) => {
                                        // setNamaPasien(e.target.value)
                                        // forceUpdate()
                                    }}
                                    inputProps={{
                                        style: {
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {

                                            color: '#7e8085',
                                        }
                                    }}
                                />
                            </div>
                            <div style={{ paddingLeft: 30, paddingRight: 30 }}>
                                <TextField
                                    style={{ width: '100%', marginTop: 30 }}
                                    id="noAntri"
                                    disabled={true}
                                    name="noAntri"
                                    label="No. Antrian"
                                    placeholder={"input No. Antrian"}
                                    value={noAntri}
                                    onChange={(e) => {
                                        // setNamaPasien(e.target.value)
                                        // forceUpdate()
                                    }}
                                    inputProps={{
                                        style: {
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {

                                            color: '#7e8085',
                                        }
                                    }}
                                />
                            </div>
                            <div style={{ marginTop: 20, paddingLeft: 30, paddingRight: 30 }}>
                                <TextField
                                    style={{ width: '100%', marginTop: 7 }}
                                    id="kode"
                                    disabled={true}
                                    name="kode"
                                    label="No Referensi"
                                    value={noReferensi === null ? "-" : noReferensi}
                                    onChange={(e) => {
                                        // setNamaPasien(e.target.value)
                                        // forceUpdate()
                                    }}
                                    inputProps={{
                                        style: {
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {

                                            color: '#7e8085',
                                        }
                                    }}
                                />
                            </div>
                            <div style={{ marginTop: 20, paddingLeft: 30, paddingRight: 30 }}>
                                <TextField
                                    style={{ width: '100%', marginTop: 7 }}
                                    id="kode"
                                    disabled={true}
                                    name="kode"
                                    label="Kode Reservasi"
                                    placeholder={"input Kode reservasi"}
                                    value={kodePesanan === null ? "-" : kodePesanan}
                                    onChange={(e) => {
                                        // setNamaPasien(e.target.value)
                                        // forceUpdate()
                                    }}
                                    inputProps={{
                                        style: {
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {

                                            color: '#7e8085',
                                        }
                                    }}
                                />
                            </div>
                            <div style={{ marginTop: 20, paddingLeft: 30, paddingRight: 30 }}>
                                <TextField
                                    style={{ width: '100%', marginTop: 7 }}
                                    id="nama"
                                    disabled={true}
                                    name="nama"
                                    label="Nama Pasien"
                                    placeholder={"input Nama Pasien"}
                                    value={namaPasien}
                                    onChange={(e) => {
                                        // setNamaPasien(e.target.value)
                                        // forceUpdate()
                                    }}
                                    inputProps={{
                                        style: {
                                            fontSize: 14,
                                            fontFamily: 'Nunito Sans, sans-serif',
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {

                                            color: '#7e8085',
                                        }
                                    }}
                                />
                            </div>
                            <div style={{ marginTop: 60, display: 'flex', justifyContent: 'space-evenly', paddingBottom: 20, borderBottomLeftRadius: 8, borderBottomRightRadius: 8 }}></div>

                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
